{
  "verticals": {
    "accounting_treatment_simulator": {
      "title": "Accounting Treatment Simulator",
      "description": "Accounting Treatment Impact Simulator (IFRS/US GAAP)"
    },
    "ai_ml": {
      "title": "AI/ML",
      "description": "Traditional machine learning models — customer data, risk scoring, insurance, and transaction monitoring."
    },
    "allowance_models": {
      "title": "Allowance Models",
      "description": "IFRS 9 / CECL expected credit loss models for wholesale portfolios."
    },
    "alm_interest_rate": {
      "title": "ALM Interest Rate",
      "description": "ALM Interest-Rate Projection Model (Multi-Scenario)"
    },
    "aml_tm": {
      "title": "AML/TM",
      "description": "Rule-Based TM — scenario/threshold logic for detecting suspicious transactions"
    },
    "auto": {
      "title": "Auto",
      "description": "Auto lending and leasing models — origination scoring, residual value, and loss forecasting."
    },
    "auto_allowance": {
      "title": "Allowance",
      "description": "Auto loan IFRS 9 / CECL expected credit loss models"
    },
    "auto_irb_lgd": {
      "title": "IRB LGD",
      "description": "Auto loan loss given default — vehicle depreciation and recovery modeling"
    },
    "auto_irb_pd": {
      "title": "IRB PD",
      "description": "Auto loan probability of default — origination and behavioral models"
    },
    "auto_scorecard": {
      "title": "Scorecard",
      "description": "Auto loan adjudication and behavioral scorecards"
    },
    "balance_sheet_optimizer": {
      "title": "Balance Sheet Optimizer",
      "description": "Balance-Sheet Optimization Solver (LP/NLP)"
    },
    "behavioral_models": {
      "title": "Behavioral Models",
      "description": "Deposit stickiness, prepayment, and callable product exercise behavior modeling."
    },
    "bond_futures": {
      "title": "Bond Futures",
      "description": "Government bond futures pricing with cheapest-to-deliver analysis"
    },
    "bond_options": {
      "title": "Bond Options",
      "description": "Options on government bonds and bond futures"
    },
    "borrower_risk_rating": {
      "title": "Borrower Risk Rating",
      "description": "Obligor-level creditworthiness assessment using financial and qualitative factors"
    },
    "callable_bond": {
      "title": "Callable Bond",
      "description": "Bonds with embedded issuer call options requiring option-adjusted spread analysis"
    },
    "callable_product_exercise": {
      "title": "Callable Product Exercise",
      "description": "Callable Product Exercise Model (Consumer & Corporate)"
    },
    "cancellable_swap": {
      "title": "Cancellable Swap",
      "description": "IR swaps with embedded Bermudan cancellation rights for one or both parties"
    },
    "capital_funding_management": {
      "title": "Capital & Funding Management",
      "description": "Regulatory capital simulation, economic capital attribution, and funding optimization."
    },
    "capital_planning_scenario": {
      "title": "Capital Planning Scenario",
      "description": "Capital Planning Scenario Engine (ICAAP/CCAR Inputs)"
    },
    "cards": {
      "title": "Cards",
      "description": "Credit card portfolio models — behavioral scoring, loss forecasting, and limit management."
    },
    "cards_allowance": {
      "title": "Allowance",
      "description": "Credit card IFRS 9 / CECL expected credit loss models"
    },
    "cards_irb_ead": {
      "title": "IRB EAD",
      "description": "Credit card exposure at default — utilization and credit conversion factors"
    },
    "cards_irb_lgd": {
      "title": "IRB LGD",
      "description": "Credit card loss given default — recovery and charge-off modeling"
    },
    "cards_irb_pd": {
      "title": "IRB PD",
      "description": "Credit card probability of default — behavioral scoring and delinquency transition"
    },
    "cards_scorecard": {
      "title": "Scorecard",
      "description": "Credit card adjudication and behavioral scorecards"
    },
    "cash_allocation": {
      "title": "Cash Allocation",
      "description": "Cash Allocation & Short-Term Investment Optimizer"
    },
    "ccr": {
      "title": "CCR",
      "description": "Counterparty Credit Risk models — SA-CCR, PFE/EE exposure simulation, and backtesting."
    },
    "ccr_backtesting": {
      "title": "CCR Backtesting",
      "description": "Backtesting of CCR exposure models against realized mark-to-market"
    },
    "cds": {
      "title": "CDS",
      "description": "Single-name credit default swaps — protection pricing and credit spread modeling"
    },
    "cdx": {
      "title": "CDX",
      "description": "Credit default swap indices — portfolio credit risk pricing and basis trading"
    },
    "cdx_options": {
      "title": "CDX Options",
      "description": "Options on CDX indices — credit spread volatility and skew modeling"
    },
    "clearing_settlement_queue": {
      "title": "Clearing Settlement Queue",
      "description": "Clearing and Settlement Queue Model"
    },
    "client_risk_rating": {
      "title": "Client Risk Rating",
      "description": "CRR — scorecard, deterministic, and ML-based client risk classification."
    },
    "commodity": {
      "title": "Commodity",
      "description": "Commodity derivative pricing models."
    },
    "commodity_american_option": {
      "title": "Commodity American Option",
      "description": "American-style commodity options with early exercise and storage cost considerations"
    },
    "commodity_cap_and_floor": {
      "title": "Commodity Cap and Floor",
      "description": "Commodity price caps and floors providing cost/revenue protection"
    },
    "commodity_european_option": {
      "title": "Commodity European Option",
      "description": "European-style options on commodity futures or spot prices"
    },
    "commodity_swap": {
      "title": "Commodity Swap",
      "description": "Fixed-for-floating commodity swaps on energy, metals, and agricultural indices"
    },
    "commodity_swaptions": {
      "title": "Commodity Swaptions",
      "description": "Options to enter commodity swaps at predetermined fixed prices"
    },
    "contingency_funding": {
      "title": "Contingency Funding",
      "description": "Contingency Funding Plan Simulator (Drawdown Sequencer)"
    },
    "convertible_bond": {
      "title": "Convertible Bond",
      "description": "Hybrid debt instruments with embedded equity conversion options"
    },
    "credit": {
      "title": "Credit",
      "description": "Credit derivative pricing models."
    },
    "credit_risk": {
      "title": "Credit Risk",
      "description": "Wholesale and retail credit risk models — risk rating, IRB parameters, allowance, and stress testing."
    },
    "cross_currency_swap": {
      "title": "Cross Currency Swap",
      "description": "Cross-currency basis swaps with notional exchange and FX reset features"
    },
    "cva": {
      "title": "CVA",
      "description": "Credit Valuation Adjustment models — accounting CVA and regulatory SA-CVA."
    },
    "cva_fva_dva_calculator": {
      "title": "CVA FVA DVA Calculator",
      "description": "CVA / FVA / DVA Calculator"
    },
    "cva_model": {
      "title": "CVA",
      "description": "Accounting CVA — expected loss from counterparty default on derivative portfolios"
    },
    "deposit_behavioral_runoff": {
      "title": "Deposit Behavioral Runoff",
      "description": "Deposit Behavioral Run-off Model (Core vs Non-Core)"
    },
    "deposit_behavioral_segmentation": {
      "title": "Deposit Behavioral Segmentation",
      "description": "Deposit Behavioral Segmentation Model"
    },
    "derivative_pricing_models": {
      "title": "Derivative Pricing Models",
      "description": "Validate derivative pricing models across FX, Equity, IR, Commodity, and Credit asset classes."
    },
    "deterministic_crr": {
      "title": "Deterministic CRR",
      "description": "Deterministic CRR — deterministic rule-based client risk rating"
    },
    "direct_cf_hedge": {
      "title": "Direct CF Hedge",
      "description": "Direct Cashflow Hedge Effectiveness Engine"
    },
    "direct_fv_hedge": {
      "title": "Direct FV Hedge",
      "description": "Direct Fair Value Hedge Effectiveness Engine"
    },
    "dynamic_cf_hedge": {
      "title": "Dynamic CF Hedge",
      "description": "Dynamic Cashflow Hedge Effectiveness Engine"
    },
    "dynamic_fv_hedge": {
      "title": "Dynamic FV Hedge",
      "description": "Dynamic Fair Value Hedge Effectiveness Engine"
    },
    "economic_capital": {
      "title": "Economic Capital",
      "description": "Economic Capital Allocation Model (Risk Attribution)"
    },
    "effectiveness_testing": {
      "title": "Effectiveness Testing",
      "description": "Hedge effectiveness assessment under IFRS 9 and US GAAP (ASC 815) frameworks."
    },
    "equity": {
      "title": "Equity",
      "description": "Equity derivative pricing models."
    },
    "equity_american_option": {
      "title": "Equity American Option",
      "description": "American-style equity options with early exercise features"
    },
    "equity_asian_option": {
      "title": "Equity Asian Option",
      "description": "Path-dependent equity options with average price or average strike payoff"
    },
    "equity_autocallable_note": {
      "title": "Equity Autocallable Note",
      "description": "Structured notes with automatic early redemption on coupon observation dates"
    },
    "equity_barrier_option": {
      "title": "Equity Barrier Option",
      "description": "Equity options that activate or extinguish at specified barrier levels"
    },
    "equity_digital_option": {
      "title": "Equity Digital Option",
      "description": "Equity options with fixed payout contingent on finishing ITM"
    },
    "equity_european_option": {
      "title": "Equity European Option",
      "description": "European-style vanilla options on equities exercisable at expiry"
    },
    "equity_forward": {
      "title": "Equity Forward",
      "description": "Forward contracts on single stocks or equity indices"
    },
    "equity_forward_starting_option": {
      "title": "Equity Forward Starting Option",
      "description": "Equity options whose strike is set on a future fixing date rather than at trade inception"
    },
    "equity_futures": {
      "title": "Equity Futures",
      "description": "Exchange-traded futures on equity indices and single stocks"
    },
    "equity_touch_option": {
      "title": "Equity Touch Option",
      "description": "Binary equity options paying fixed amount on touching a barrier"
    },
    "eve_calculator": {
      "title": "EVE Calculator",
      "description": "EVE Calculator (Regulatory Shock Suite)"
    },
    "facility_risk_rating": {
      "title": "Facility Risk Rating",
      "description": "Facility-level risk assessment incorporating collateral, structure, and seniority"
    },
    "fair_value_hierarchy": {
      "title": "Fair Value Hierarchy",
      "description": "Fair Value Hierarchy Reconciler"
    },
    "financial_crimes": {
      "title": "Financial Crimes",
      "description": "AML transaction monitoring, client risk rating, and sanctions screening models."
    },
    "financial_resource_optimization": {
      "title": "Financial Resource Optimization",
      "description": "Funds transfer pricing, balance-sheet optimization, capital and funding management."
    },
    "fraud": {
      "title": "Fraud",
      "description": "Fraud detection and prevention models — transaction, account, login, and claims fraud scoring."
    },
    "fraud_account_scoring": {
      "title": "Account Scoring",
      "description": "Bank Account Connectivity-Based Fraud Risk Scoring Platform"
    },
    "fraud_call_risk_scoring": {
      "title": "Call Risk Scoring",
      "description": "Telephone Call Risk Assessment and Prioritization Solution"
    },
    "fraud_credit_card_claims": {
      "title": "Credit Card Claims",
      "description": "Credit Card Dispute Fraud Likelihood Assessment System"
    },
    "fraud_credit_risk": {
      "title": "Credit Risk",
      "description": "Residential Mortgage Application Risk Classifier"
    },
    "fraud_data_loss_prevention": {
      "title": "Data Loss Prevention",
      "description": "Employee Print Activity Anomaly Detection System"
    },
    "fraud_insurance_investigation": {
      "title": "Insurance Investigation",
      "description": "Automotive Claim Investigation Recommendation Solution"
    },
    "fraud_login_portal": {
      "title": "Login Portal",
      "description": "Online and Mobile Login Portal Fraud Detection Solution"
    },
    "fraud_online_banking": {
      "title": "Online Banking",
      "description": "Online Banking Transaction Risk Scoring and Monitoring System"
    },
    "fraud_transaction_detection": {
      "title": "Transaction Detection",
      "description": "Real-Time Transaction Anomaly Detection for ATM, Mobile, Withdrawals, Debit"
    },
    "fraud_transaction_monitoring": {
      "title": "Transaction Monitoring",
      "description": "High-Risk Wire Transaction Scoring Solution"
    },
    "fraud_wealth_segmentation": {
      "title": "Wealth Segmentation",
      "description": "Wealth Portfolio Segmentation and Feature Selection"
    },
    "ftp_curve_construction": {
      "title": "FTP Curve Construction",
      "description": "FTP Curve Construction and Calibration Module"
    },
    "funding_concentration": {
      "title": "Funding Concentration",
      "description": "Funding Concentration and Counterparty Exposure Model (ICAAP/CCAR Inputs)"
    },
    "funding_cost_allocation": {
      "title": "Funding Cost Allocation",
      "description": "Funding Cost Allocation Model (Transactional FTP)"
    },
    "funding_mix_optimization": {
      "title": "Funding Mix Optimization",
      "description": "Funding Mix & Tenor Optimization Model"
    },
    "funding_mix_tenor": {
      "title": "Funding Mix Tenor",
      "description": "Funding Mix and Tenor Optimization Model (Cost vs Liquidity)"
    },
    "funds_transfer_pricing": {
      "title": "Funds Transfer Pricing",
      "description": "Internal pricing of funds between business lines and treasury."
    },
    "fx": {
      "title": "FX",
      "description": "Foreign exchange derivative pricing models."
    },
    "fx_american_option": {
      "title": "FX American Option",
      "description": "American-style FX options exercisable at any time up to expiry"
    },
    "fx_asian_option": {
      "title": "FX Asian Option",
      "description": "Path-dependent FX options with payoff based on average rate over a period"
    },
    "fx_barrier_option": {
      "title": "FX Barrier Option",
      "description": "FX options that activate or extinguish when the spot rate crosses a barrier level"
    },
    "fx_digital_option": {
      "title": "FX Digital Option",
      "description": "FX options with a fixed payout contingent on spot finishing above or below a strike"
    },
    "fx_european_option": {
      "title": "FX European Option",
      "description": "European-style vanilla FX options exercisable only at expiry"
    },
    "fx_forward": {
      "title": "FX Forward",
      "description": "Outright forward contracts on currency pairs with settlement at a future date"
    },
    "fx_futures": {
      "title": "FX Futures",
      "description": "Exchange-traded standardized currency futures contracts"
    },
    "fx_range_accrual": {
      "title": "FX Range Accrual",
      "description": "Structured FX notes accruing coupon based on days spot stays within a range"
    },
    "fx_touch_option": {
      "title": "FX Touch Option",
      "description": "Binary FX options that pay a fixed amount if spot touches a specified level"
    },
    "genai": {
      "title": "GenAI",
      "description": "Generative AI models — underwriting, surveillance, code generation, chatbots, and summarization."
    },
    "genai_carrier_booklet_extraction": {
      "title": "Carrier Booklet Extraction",
      "description": "Prior Carrier Booklet Data Extraction and Structuring Tool"
    },
    "genai_chatbots": {
      "title": "Chatbots",
      "description": "Internal Knowledge and Support Chatbot Ecosystem"
    },
    "genai_code_assistant": {
      "title": "Code Assistant",
      "description": "Developer Productivity and Code Generation Assistant Suite"
    },
    "genai_code_conversion": {
      "title": "Code Conversion",
      "description": "Legacy FOCUS Code Explanation and Conversion Platform"
    },
    "genai_comms_monitoring": {
      "title": "Communications Monitoring",
      "description": "Employee Communications Monitoring and Compliance Detection System"
    },
    "genai_news_classification": {
      "title": "News Classification",
      "description": "External News Event Categorization and Summarization Solution"
    },
    "genai_summarization": {
      "title": "Summarization",
      "description": "Automated Call Center Conversation Summarization Platform"
    },
    "genai_surveillance": {
      "title": "Surveillance",
      "description": "Employee communication and voice surveillance for compliance risk detection."
    },
    "genai_underwriting": {
      "title": "Underwriting",
      "description": "GenAI-powered underwriting recommendation and data extraction."
    },
    "genai_underwriting_recommendation": {
      "title": "Underwriting Recommendation",
      "description": "Automated Underwriting Recommendation and Assistance Platform"
    },
    "genai_voice_surveillance": {
      "title": "Voice Surveillance",
      "description": "Employee Voice Communication Surveillance and Risk Detection"
    },
    "hedge_accounting": {
      "title": "Hedge Accounting",
      "description": "Hedge valuation and effectiveness testing models."
    },
    "hedge_rebalancing_backtest": {
      "title": "Hedge Rebalancing Backtest",
      "description": "Hedge Rebalancing & Effectiveness Back-test Model"
    },
    "hedge_rebalancing_scheduler": {
      "title": "Hedge Rebalancing Scheduler",
      "description": "Hedge Rebalancing Scheduler and Trade Recommendation Module"
    },
    "heloc": {
      "title": "HELOC",
      "description": "Home equity line of credit models — drawdown behavior, collateral monitoring, and loss forecasting."
    },
    "heloc_allowance": {
      "title": "Allowance",
      "description": "HELOC IFRS 9 / CECL expected credit loss models"
    },
    "heloc_irb_ead": {
      "title": "IRB EAD",
      "description": "HELOC exposure at default — drawdown behavior and utilization modeling"
    },
    "heloc_irb_lgd": {
      "title": "IRB LGD",
      "description": "HELOC loss given default — combined lien position and property value modeling"
    },
    "heloc_irb_pd": {
      "title": "IRB PD",
      "description": "HELOC probability of default — combined mortgage and revolving risk factors"
    },
    "intraday_limit_breach": {
      "title": "Intraday Limit Breach",
      "description": "Intraday Limit Breach Predictor"
    },
    "intraday_liquidity_engine": {
      "title": "Intraday Liquidity Engine",
      "description": "Payment Flow Simulator"
    },
    "ir": {
      "title": "IR",
      "description": "Interest rate derivative pricing models."
    },
    "ir_bermudan_swaption": {
      "title": "IR Bermudan Swaption",
      "description": "Bermudan swaptions with multiple exercise dates requiring tree/MC methods"
    },
    "ir_range_accrual": {
      "title": "IR Range Accrual",
      "description": "Interest rate range accrual notes accruing coupon based on days a reference rate stays within a corridor"
    },
    "ir_cap_and_floor": {
      "title": "IR Cap and Floor",
      "description": "Interest rate caps and floors — strips of caplets/floorlets on floating rates"
    },
    "ir_european_swaption": {
      "title": "IR European Swaption",
      "description": "European-style swaptions — right to enter an IR swap at a fixed rate at expiry"
    },
    "ir_future_options": {
      "title": "IR Future Options",
      "description": "Options on short-term interest rate futures contracts"
    },
    "ir_futures": {
      "title": "IR Futures",
      "description": "Short-term interest rate futures (Eurodollar, SOFR) pricing and convexity adjustment"
    },
    "ir_swap": {
      "title": "IR Swap",
      "description": "Plain vanilla and basis interest rate swaps with multi-curve discounting"
    },
    "irb_parameter_models": {
      "title": "IRB Parameter Models",
      "description": "Internal ratings-based parameter estimation for regulatory capital."
    },
    "irrbb_measurement": {
      "title": "IRRBB Measurement",
      "description": "Economic value and net interest income sensitivity to interest rate changes."
    },
    "irrbb_reporting_reconciler": {
      "title": "IRRBB Reporting Reconciler",
      "description": "IRRBB Reporting Reconciler"
    },
    "isda_simm": {
      "title": "ISDA SIMM",
      "description": "ISDA SIMM — sensitivity-based initial margin calculation across risk classes"
    },
    "issuance_timing": {
      "title": "Issuance Timing",
      "description": "Issuance Timing and Pricing Optimizer"
    },
    "lcr_calculator": {
      "title": "LCR Calculator",
      "description": "High Frequency Reconciliation Module"
    },
    "lcr_nsfr_nccf_mapping": {
      "title": "LCR NSFR NCCF Mapping",
      "description": "LCR/NSFR/NCCF Cashflow Mapping Engine"
    },
    "liquidity": {
      "title": "Liquidity",
      "description": "Regulatory reporting, short-term forecasting, long-term planning, and stress testing."
    },
    "liquidity_buffer_drawdown": {
      "title": "Liquidity Buffer Drawdown",
      "description": "Liquidity Buffer Drawdown Model (Asset Liquidation Sequencer)"
    },
    "liquidity_cost_minimization": {
      "title": "Liquidity Cost Minimization",
      "description": "Liquidity Cost Minimization Model (Penalty Functions)"
    },
    "liquidity_ratio_reconciler": {
      "title": "Liquidity Ratio Reconciler",
      "description": "Submission Pack Generator"
    },
    "liquidity_stress": {
      "title": "Liquidity Stress",
      "description": "Liquidity Stress Scenario Engine (Regulatory & Internal Scenarios)"
    },
    "long_term_planning": {
      "title": "Long-Term Planning",
      "description": "Medium to long-term liquidity projection, maturity management, and behavioral modeling."
    },
    "machine_learning": {
      "title": "Machine Learning Models",
      "description": "AI/ML, NLP, GenAI, and fraud detection models across insurance, banking, and enterprise domains."
    },
    "market_risk": {
      "title": "Market Risk",
      "description": "VaR/ES, counterparty credit risk, CVA, and SIMM models for trading portfolios and derivatives."
    },
    "maturity_ladder": {
      "title": "Maturity Ladder",
      "description": "Maturity Ladder Aggregator and Roll-Forward Engine"
    },
    "medium_term_liquidity": {
      "title": "Medium Term Liquidity",
      "description": "Medium-Term Liquidity Projection 1-12m (Scenario Blend)"
    },
    "ml_based_crr": {
      "title": "ML Based CRR",
      "description": "ML-Based CRR — machine learning-based client risk classification"
    },
    "ml_based_tm": {
      "title": "ML Based TM",
      "description": "ML-Based TM — feature-based trained models (gradient boosted trees, NLP, GenAI)"
    },
    "ml_credit_distress_prediction": {
      "title": "Credit Distress Prediction",
      "description": "Business Partner Credit Distress Prediction Platform"
    },
    "ml_credit_risk_assessment": {
      "title": "Credit Risk Assessment",
      "description": "ML-driven credit risk prediction, segmentation, and classification models."
    },
    "ml_customer_data_mgmt": {
      "title": "Customer Data Management",
      "description": "Client Demographic Reconciliation and Matching Engine"
    },
    "ml_data_loss_prevention": {
      "title": "Data Loss Prevention",
      "description": "Employee Print Activity Anomaly Detection System"
    },
    "ml_etl_preprocessing": {
      "title": "ETL/Preprocessing",
      "description": "Data Extraction, Transformation, and Feature Engineering Pipeline"
    },
    "ml_high_risk_wire_scoring": {
      "title": "High-Risk Wire Transaction Scoring",
      "description": "High-Risk Wire Transaction Scoring Solution"
    },
    "ml_insurance_investigation": {
      "title": "Insurance Investigation",
      "description": "Automotive Claim Investigation Recommendation Solution"
    },
    "ml_insurance_pricing": {
      "title": "Insurance Pricing",
      "description": "Residential Insurance Claim Severity Prediction Tool"
    },
    "ml_insurance_underwriting": {
      "title": "Insurance Underwriting",
      "description": "Real-Time Life Insurance Underwriting Decision System"
    },
    "ml_marketing": {
      "title": "Marketing",
      "description": "Retail Customer Marketing Recommendation Engine"
    },
    "ml_mortgage_risk_classifier": {
      "title": "Mortgage Risk Classifier",
      "description": "Residential Mortgage Application Risk Classifier"
    },
    "ml_transaction_monitoring": {
      "title": "Transaction Monitoring",
      "description": "ML-based transaction scoring and alert reduction for wire transfers."
    },
    "ml_wealth_portfolio_selection": {
      "title": "Wealth Portfolio Feature Selection",
      "description": "Wealth Portfolio Segmentation and Feature Selection"
    },
    "ml_wealth_segmentation": {
      "title": "Wealth Customer Segmentation",
      "description": "Wealth Customer Segmentation and Advisory Clustering"
    },
    "ml_wire_alert_reduction": {
      "title": "Wire Alert Reduction",
      "description": "Personal Banking Wire Alert Reduction System"
    },
    "mortgage": {
      "title": "Mortgage",
      "description": "Residential mortgage lending models — IRB parameters, scorecards, allowance, and stress testing."
    },
    "mortgage_allowance": {
      "title": "Allowance",
      "description": "Mortgage IFRS 9 / CECL expected credit loss models with HPI scenarios"
    },
    "mortgage_irb_ead": {
      "title": "IRB EAD",
      "description": "Mortgage exposure at default — amortization, prepayment, and HELOC drawdown modeling"
    },
    "mortgage_irb_lgd": {
      "title": "IRB LGD",
      "description": "Mortgage loss given default — collateral valuation, recovery rates, and insurance coverage"
    },
    "mortgage_irb_pd": {
      "title": "IRB PD",
      "description": "Mortgage probability of default — pool segmentation, calibration, and regulatory floors per OSFI CAR"
    },
    "mortgage_scorecard": {
      "title": "Scorecard",
      "description": "Mortgage adjudication and behavioral scorecards for credit decisioning"
    },
    "mortgage_stress": {
      "title": "Stress Testing",
      "description": "Mortgage stressed loss projections under adverse housing and macro scenarios"
    },
    "name_screening": {
      "title": "Name Screening",
      "description": "Client/counterparty name matching against sanctions and watchlists"
    },
    "nii_projection": {
      "title": "NII Projection",
      "description": "NII Projection Model (Base, Adverse, Severe)"
    },
    "nii_shock_simulator": {
      "title": "NII Shock Simulator",
      "description": "NII Shock Simulator (Parallel, Twist, Custom)"
    },
    "nlp": {
      "title": "NLP",
      "description": "Natural language processing models — classification, entity recognition, sentiment, and summarization."
    },
    "nlp_chatbots": {
      "title": "Chatbots",
      "description": "Internal Employee Support and Information Chatbot Suite"
    },
    "nlp_document_masking": {
      "title": "Document Masking",
      "description": "Survey Comment Anonymization and PII Masking Solution"
    },
    "nlp_intent_classification": {
      "title": "Intent Classification",
      "description": "Call Center Client Intent Categorization Platform"
    },
    "nlp_marketing_asset_analysis": {
      "title": "Marketing Asset Analysis",
      "description": "Social Media Marketing Asset Evaluation and Scoring Solution"
    },
    "nlp_named_entity_recognition": {
      "title": "Named Entity Recognition",
      "description": "Personal Name Identification and Masking for Survey Comments"
    },
    "nlp_news_classification": {
      "title": "News Classification",
      "description": "External News Event Categorization for Audit Planning"
    },
    "nlp_sentiment_analysis": {
      "title": "Sentiment Analysis",
      "description": "Survey Comment Sentiment Detection and Labeling System"
    },
    "nlp_summarization": {
      "title": "Summarization",
      "description": "Call Center Conversation Summarization and Transcription Tool"
    },
    "nlp_topic_classification": {
      "title": "Topic Classification",
      "description": "Survey Comment Topic Categorization and Analysis Tool"
    },
    "ois_discounting": {
      "title": "OIS Discounting",
      "description": "OIS Discounting and Basis Adjustment Module"
    },
    "operational_risk_simulator": {
      "title": "Operational Risk Simulator",
      "description": "Operational Risk Simulator (ICAAP/CCAR Inputs)"
    },
    "option_adjusted_valuation": {
      "title": "Option Adjusted Valuation",
      "description": "Option-Adjusted Valuation (OAV) Model"
    },
    "parameter_calibration": {
      "title": "Parameter Calibration",
      "description": "Calibration of drift, volatility, and correlation parameters for exposure simulation"
    },
    "payment_flow_concentration": {
      "title": "Payment Flow Concentration",
      "description": "Payment-Flow Concentration Analyzer"
    },
    "payment_screening": {
      "title": "Payment Screening",
      "description": "Payment message screening against sanctions lists"
    },
    "personal_allowance": {
      "title": "Allowance",
      "description": "Personal lending IFRS 9 / CECL expected credit loss models"
    },
    "personal_irb_lgd": {
      "title": "IRB LGD",
      "description": "Personal lending loss given default — unsecured recovery modeling"
    },
    "personal_irb_pd": {
      "title": "IRB PD",
      "description": "Personal lending probability of default — unsecured risk assessment"
    },
    "personal_lending": {
      "title": "Personal Lending",
      "description": "Unsecured personal loan and line of credit models."
    },
    "personal_scorecard": {
      "title": "Scorecard",
      "description": "Personal lending adjudication and behavioral scorecards"
    },
    "pfe_ee": {
      "title": "PFE/EE",
      "description": "Potential Future Exposure and Expected Exposure simulation models."
    },
    "precious_metal_range_accrual": {
      "title": "Precious Metal Range Accrual",
      "description": "Structured notes accruing coupon based on gold/silver prices staying within a range"
    },
    "prepayment_cpr": {
      "title": "Prepayment CPR",
      "description": "Prepayment / CPR Model (Mortgage Seasoning & Burnout)"
    },
    "rate_scenario_monte_carlo": {
      "title": "Rate Scenario Monte Carlo",
      "description": "Rate-Scenario Monte Carlo Engine (Stochastic Paths)"
    },
    "recovery_funding": {
      "title": "Recovery Funding",
      "description": "Recovery Funding Sequencer (Funding Source Prioritization)"
    },
    "regulatory_capital_simulator": {
      "title": "Regulatory Capital Simulator",
      "description": "Regulatory Capital Impact Simulator (Basel)"
    },
    "regulatory_reporting": {
      "title": "Regulatory Reporting",
      "description": "LCR, NSFR, and NCCF regulatory liquidity ratio calculation and reconciliation."
    },
    "repricing_ladder": {
      "title": "Repricing Ladder",
      "description": "Repricing Ladder Aggregator (By Bucket and Product)"
    },
    "retail": {
      "title": "Retail",
      "description": "Retail credit risk models for consumer lending portfolios."
    },
    "retail_deposit_stickiness": {
      "title": "Retail Deposit Stickiness",
      "description": "Retail Deposit Stickiness and Decay Model"
    },
    "reverse_liquidity_stress": {
      "title": "Reverse Liquidity Stress",
      "description": "Reverse Liquidity Stress Tester (Idiosyncratic & Market)"
    },
    "risk_rating_models": {
      "title": "Risk Rating Models",
      "description": "Borrower and facility-level credit risk rating models."
    },
    "run_off_roll_rate": {
      "title": "Run Off Roll Rate",
      "description": "Run-off and Roll-Rate Model (by product)"
    },
    "sa_ccr": {
      "title": "SA-CCR",
      "description": "Standardised Approach for Counterparty Credit Risk — regulatory EAD calculation"
    },
    "sa_cva": {
      "title": "SA-CVA",
      "description": "Standardised Approach CVA — regulatory capital charge for CVA risk (FRTB)"
    },
    "sabr_vol_calibration": {
      "title": "SABR Vol Calibration",
      "description": "SABR stochastic volatility model calibration for swaption and cap/floor vol surfaces"
    },
    "sanctions_screening": {
      "title": "Sanctions Screening",
      "description": "Name screening and payment screening against sanctions and watchlists."
    },
    "scenario_asset_allocation": {
      "title": "Scenario Asset Allocation",
      "description": "Scenario-Based Asset Allocation Engine (Stress-Aware)"
    },
    "scorecard_ph": {
      "title": "Scorecard PH",
      "description": "Scorecard-Based PH — additive scoring with EDD threshold for Potential High risk clients"
    },
    "short_term_cashflow_branch": {
      "title": "Short Term Cashflow Branch",
      "description": "Short-Term Cashflow Forecast (Branch & Wholesale)"
    },
    "short_term_cashflow_treasury": {
      "title": "Short Term Cashflow Treasury",
      "description": "Short-Term Cashflow Forecast (Treasury Desk)"
    },
    "short_term_forecasting": {
      "title": "Short-Term Forecasting",
      "description": "Intraday and short-term cashflow forecasting for treasury operations."
    },
    "simm": {
      "title": "SIMM",
      "description": "Standard Initial Margin Model for non-cleared OTC derivatives."
    },
    "simm_backtesting": {
      "title": "Backtesting",
      "description": "SIMM backtesting — margin adequacy validation against realized P&L"
    },
    "simulation_exposure_generation": {
      "title": "Simulation and Exposure Generation",
      "description": "Monte Carlo simulation engine for PFE/EE profile generation"
    },
    "strategic_ftp": {
      "title": "Strategic FTP",
      "description": "Strategic FTP Optimizer (Business Line Margins)"
    },
    "stress_funding_recovery": {
      "title": "Stress Funding Recovery",
      "description": "Stress Funding & Recovery Planner (Regulatory Scenarios)"
    },
    "stress_period_selection": {
      "title": "Stress Period Selection",
      "description": "Stressed VaR calibration — identification of the most adverse historical stress window"
    },
    "stress_testing_aggregation": {
      "title": "Stress Testing",
      "description": "Liquidity stress scenario engines, reverse stress testing, and contingency funding."
    },
    "stress_testing_models": {
      "title": "Stress Testing Models",
      "description": "Stress testing parameter models for ICAAP, CCAR, and regulatory scenarios."
    },
    "structural_market_risk": {
      "title": "Structural (Non-trading) Market Risk",
      "description": "IRRBB measurement, behavioral models, and yield curve construction."
    },
    "transaction_monitoring": {
      "title": "Transaction Monitoring",
      "description": "AML/ATF transaction monitoring — rule-based and ML-based detection models."
    },
    "transactional_ftp": {
      "title": "Transactional FTP",
      "description": "Transactional FTP Engine (Deal Level)"
    },
    "treasury": {
      "title": "Treasury",
      "description": "Liquidity, structural market risk, financial resource optimization, and hedge accounting models."
    },
    "treasury_portfolio_rebalancer": {
      "title": "Treasury Portfolio Rebalancer",
      "description": "Treasury Portfolio Rebalancer (Duration and Liquidity Targets)"
    },
    "valuation": {
      "title": "Valuation",
      "description": "Fair value measurement including CVA, FVA, DVA, and valuation hierarchy."
    },
    "var_es": {
      "title": "VaR/ES",
      "description": "Value at Risk and Expected Shortfall models for trading book risk measurement."
    },
    "var_es_engine": {
      "title": "VaR/ES Engine",
      "description": "Historical simulation, parametric, and Monte Carlo VaR/ES computation engines"
    },
    "wholesale": {
      "title": "Wholesale",
      "description": "Wholesale credit risk models for commercial, corporate, and financial institution exposures."
    },
    "wholesale_ead_calibration": {
      "title": "EAD Calibration",
      "description": "Credit conversion factor estimation and EAD calibration"
    },
    "wholesale_ead_segmentation": {
      "title": "EAD Segmentation",
      "description": "Exposure at default segmentation for revolving and term facilities"
    },
    "wholesale_ecl_ead": {
      "title": "ECL EAD",
      "description": "Lifetime EAD estimation for ECL with amortization and drawdown profiles"
    },
    "wholesale_ecl_lgd": {
      "title": "ECL LGD",
      "description": "Lifetime LGD estimation for ECL with recovery curve modeling"
    },
    "wholesale_ecl_pd": {
      "title": "ECL PD",
      "description": "Point-in-time PD with forward-looking information for ECL estimation"
    },
    "wholesale_lgd_calibration": {
      "title": "LGD Calibration",
      "description": "Downturn LGD calibration with workout and recovery modeling"
    },
    "wholesale_lgd_segmentation": {
      "title": "LGD Segmentation",
      "description": "Loss given default segmentation by collateral type and seniority"
    },
    "wholesale_pd_calibration": {
      "title": "PD Calibration",
      "description": "Long-run average PD calibration and margin of conservatism"
    },
    "wholesale_pd_segmentation": {
      "title": "PD Segmentation",
      "description": "Probability of default risk segmentation and pool assignment"
    },
    "wholesale_sicr": {
      "title": "SICR",
      "description": "Significant increase in credit risk staging model (Stage 1/2/3 assignment)"
    },
    "wholesale_stress_ead": {
      "title": "Stress EAD",
      "description": "Stressed EAD estimation with drawdown behavior under stress"
    },
    "wholesale_stress_lgd": {
      "title": "Stress LGD",
      "description": "Stressed LGD estimation under downturn conditions"
    },
    "wholesale_stress_pd": {
      "title": "Stress PD",
      "description": "Stressed PD projection under adverse macroeconomic scenarios"
    },
    "yield_curve_construction": {
      "title": "Yield Curve Construction",
      "description": "Yield Curve Construction and Bootstrapping Engine"
    },
    "yield_curve_models": {
      "title": "Yield Curve Models",
      "description": "Yield curve construction, bootstrapping, and multi-curve framework."
    },
    "capital_models": {
      "title": "Capital Models",
      "description": "Regulatory capital computation and FRTB-related approaches for trading book market risk."
    },
    "frtb": {
      "title": "FRTB",
      "description": "Fundamental Review of the Trading Book — Standardised Approach (SA) and Internal Models Approach (IMA) for market risk capital."
    },
    "insurance": {
      "title": "Insurance",
      "description": "Insurance and actuarial models — pricing, reserving, capital, and experience studies."
    },
    "life": {
      "title": "Life",
      "description": "Life insurance and annuity models — pricing, valuation, capital, and experience studies."
    },
    "life_valuation": {
      "title": "Valuation",
      "description": "Calculation of the insurer's liabilities, reserves, and financial results for life insurance policies."
    },
    "p_and_c": {
      "title": "P&C",
      "description": "Property and casualty models — pricing, reserving, and capital."
    },
    "pricing": {
      "title": "Pricing",
      "description": "Pricing and rate-setting models."
    },
    "reserving": {
      "title": "Reserving",
      "description": "Claims reserving and liability estimation models."
    }
  },
  "serviceTypes": {
    "Auditing": {
      "title": "Auditing",
      "description": "Comprehensive audit of model governance, controls, and regulatory compliance"
    },
    "Development": {
      "title": "Development",
      "description": "Model development, enhancement, and documentation support"
    },
    "Validation": {
      "title": "Validation",
      "description": "Independent review and validation of model assumptions, methodology, and outputs"
    }
  },
  "generic": {
    "title": "Generic Task",
    "description": "Validate or audit a model that doesn't fit a predefined category."
  },
  "inventory": {
    "models": {
      "1": {
        "name": "Credit Risk PD Model v2.1",
        "type": "Credit Risk",
        "description": "Probability of Default model for retail mortgage portfolios",
        "owner": "Risk Analytics Team",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Retail",
        "dataSource": "Internal Credit Database"
      },
      "3": {
        "name": "EAD Calculation Model",
        "type": "Credit Risk",
        "description": "Exposure at Default calculation for credit risk capital requirements",
        "owner": "Capital Management",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Wholesale",
        "dataSource": "Transaction Database"
      },
      "4": {
        "name": "Credit Scoring Model - Retail",
        "type": "Credit Risk",
        "description": "Application scoring model for retail credit products",
        "owner": "Consumer Banking",
        "regulatoryFramework": "Fair Lending",
        "modelCategory": "Retail",
        "dataSource": "Application Data"
      },
      "2": {
        "name": "LGD Estimation Model",
        "type": "Credit Risk",
        "description": "Loss Given Default estimation model for corporate lending",
        "owner": "Credit Risk Team",
        "regulatoryFramework": "IFRS 9",
        "modelCategory": "Corporate",
        "dataSource": "Historical Loss Data"
      },
      "11": {
        "name": "Market Risk VaR Model",
        "type": "Market Risk",
        "description": "Value at Risk calculation for trading portfolio risk management",
        "owner": "Market Risk Team",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Trading",
        "dataSource": "Market Data Feed"
      },
      "12": {
        "name": "Market Risk Greeks Calculator",
        "type": "Market Risk",
        "description": "Delta, Gamma, Vega, and Theta calculations for derivatives portfolio",
        "owner": "Derivatives Desk",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Derivatives",
        "dataSource": "Pricing Engine"
      },
      "50": {
        "name": "FX European Option Pricer",
        "type": "Pricing Models",
        "description": "Closed-form pricer for vanilla European FX options",
        "owner": "Model Development",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "FX",
        "dataSource": "Market Data Feed"
      },
      "51": {
        "name": "IR Swap Pricer",
        "type": "Pricing Models",
        "description": "Discounting + projection curve swap pricer and sensitivities",
        "owner": "Quant Research",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "IR",
        "dataSource": "Curve Builder"
      },
      "52": {
        "name": "Commodity European Option Pricer",
        "type": "Pricing Models",
        "description": "Vanilla commodity option pricer with calibration hooks"
      }
    },
    "statuses": {
      "Active": "Active",
      "Draft": "Draft",
      "Deprecated": "Deprecated"
    }
  }
}
